import {
    Button,
    ButtonVariant,
    ColorSchemes,
    componentStyles,
    SimpleInlineErrorMessage,
    VerticalStack,
} from "@mallardbay/lib-react-components"
import React, { useCallback, useMemo } from "react"

import COPY from "~config/copy-constants"
import { TEST_IDS } from "~config/constants"

interface Props {
    readonly error: Error
    readonly onRetry?: () => void
}

export default function ChatErrorBanner({ error, onRetry }: Props) {
    const styles = useStyles()
    // Ignore the React MouseEvent so it doesn't leak into downstream APIs
    // that interpret the first argument as options (e.g. the AI SDK's
    // `regenerate`).
    const handleRetryClick = useCallback(() => onRetry?.(), [onRetry])
    const displayedError = useMemo(
        () => ({ message: error.message || COPY.AI_CHAT_ERROR_FALLBACK }),
        [error.message]
    )

    return (
        <VerticalStack style={styles.root} testId={TEST_IDS.CHAT_ERROR_BANNER}>
            <SimpleInlineErrorMessage error={displayedError} />
            {onRetry && (
                <Button
                    testId={TEST_IDS.CHAT_ERROR_RETRY_BUTTON}
                    onClick={handleRetryClick}
                    variant={ButtonVariant.Outline}
                    colorScheme={ColorSchemes.Brand}
                >
                    {COPY.AI_CHAT_RETRY}
                </Button>
            )}
        </VerticalStack>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            alignItems: "stretch",
            gap: 2,
        },
    })
}
